<script>
  import { onMount } from 'svelte';
  import { writable, derived} from 'svelte/store';


  let image1 = null;
  let image2 = null;
  let images = [
    { url: 'images/egg.png', text: 'egg' },
    { url: 'images/egg1.png', text: 'sunny side up' },
    { url: 'images/egg2.png', text: 'over easy egg' },
    { url: 'images/egg3.png', text: 'over hard egg' }
  ];
  let currentImageIndex = writable(0);

  let imageUrl = derived(currentImageIndex, $currentImageIndex => imageUrls[$currentImageIndex]);


  onMount(() => {
    image1.addEventListener('dragstart', handleDragStart, false);
    image2.addEventListener('dragover', handleDragOver, false);
    image2.addEventListener('drop', handleDrop, false);
  });

  function handleDragStart(e) {
    e.dataTransfer.setData('text/plain', e.target.id);
  }

  function handleDragOver(e) {
    e.preventDefault(); // 기본 처리 방지
  }

  function handleDrop(e) {
    e.preventDefault();
    const data = e.dataTransfer.getData('text/plain');
    if(data === 'image1') {
      currentImageIndex.update(index => {
        if(index < images.length - 1) {    
          return index + 1;                   
        }
        return index;           // 배열의 마지막에 도달하지 않았다면 인덱스를 1 증가, 이미 배열의 마지막에 도달했다면 인덱스 변경 없음
      });
    }
  }


</script>

<style>
  .image img {
    pointer-events: none;
    width: 100%;
    height: 100%;
    object-fit: cover; 
  }
  .image {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .image1 {
    width: 200px;
    height: 200px;
  }
  .image2 {
    width: 500px; 
    height: 500px;
  }

  .container {
    display: flex;
    flex-direction: column;
    justify-content: center; 
    align-items: center; 
    height: 100vh;
  }
</style>
<div class="container">
<div id="image1" draggable="true" bind:this={image1}> 
  <div class="image image1">
    <img src={images[$currentImageIndex].url} alt="egg">
    <p>{images[$currentImageIndex].text}</p>
  </div>
</div>  

<div id="image2" bind:this={image2}>
  <div class="image image2">
    <img src="images/pan.png" alt="pan">
  </div>
</div>
</div>



<audio src="sounds/Lobby-Time(chosic.com).mp3" autoplay loop></audio>